import * as React from 'react';

import PropTypes from 'prop-types';

import Naptime from 'bundles/naptimejs';

const withNaptimeAsProp = (Component: $TSFixMe) => {
  const componentName = Component.displayName || Component.name;
  const ComposedComponent = (props: $TSFixMe, context: $TSFixMe) => {
    const naptime = props.naptime;
    return <Component {...props} naptime={naptime} />;
  };

  ComposedComponent.propTypes = {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'NaptimeProp' does not exist on type 'typ... Remove this comment to see the full error message
    naptime: PropTypes.instanceOf(Naptime.NaptimeProp),
  };

  ComposedComponent.displayName = componentName + 'withNaptimeAsProp';

  return Naptime.createContainer(ComposedComponent, () => ({}));
};

export default withNaptimeAsProp;
